export const newMessagePlaceholderId = 'placeholder';
